import React from "react";
import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { Dispatcher, SiteInfo } from "./siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { isTransitionalArmedStatus } from "../../SitesPage/SitesPageUtils/armedStatusPresentation";

/**
 * Poll `/about/` every 5 s while the site reports ARMING / DISARMING so the
 * toggle, tooltip and status chip follow the backend.
 *
 * Despite the historical name this no longer disables anything (SUP-515):
 * every poll clears the disabled flag and pushes the latest `armed` /
 * `armed_status` into siteInfo so the chip re-labels as the state moves.
 */
export const siteArmButtonDisableCheckRefresh = (
  siteId: string,
  setArmButtonDisabled: Dispatcher<boolean>,
  navigate: NavigateFunction,
  setSiteInfo: Dispatcher<SiteInfo>,
  setArmedStatus: any,
  getIsMounted?: () => boolean
) => {
  const retryFunction = () => {
    if (getIsMounted && !getIsMounted()) return;
    siteArmButtonDisableCheckRefresh(
      siteId,
      setArmButtonDisabled,
      navigate,
      setSiteInfo,
      setArmedStatus,
      getIsMounted
    );
  };

  const AxiosUI = createApi(``);

  AxiosUI.get(`customer/${siteId}/about/`).then(
    (response: AxiosResponse) => {
      if (getIsMounted && !getIsMounted()) return;
      const armed =
        response.data.armed_status === "ARMED_OUTSIDE_SCHEDULE"
          ? true
          : response.data.armed;
      setArmedStatus(armed);
      setArmButtonDisabled(false);
      setSiteInfo((previousState: SiteInfo) => {
        return {
          ...previousState,
          armed,
          armed_status: response.data.armed_status,
        };
      });
      if (isTransitionalArmedStatus(response.data.armed_status)) {
        setTimeout(() => {
          if (getIsMounted && !getIsMounted()) return;
          if (localStorage.armButtonCheckURL === window.location.pathname) {
            siteArmButtonDisableCheckRefresh(
              siteId,
              setArmButtonDisabled,
              navigate,
              setSiteInfo,
              setArmedStatus,
              getIsMounted
            );
          } else {
            localStorage.setItem("armButtonCheckURL", "");
          }
        }, 5000);
      }
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
    }
  );
};
